module.exports = __webpack_public_path__ + "assets/img/swj_logo.33d97f7c.png";